export function resetAnalyticsUser(): void {
	if (typeof window === "undefined") return;
	(window as any).posthog?.reset();
}
